/**
 * useFiltersConfig
 */
import { useMemo } from 'react';

import useMediaConfigSearch from 'bdvp-common/src/hooks/config/useMediaConfigSearch';

const useFiltersConfig = () => {

    const config = useMediaConfigSearch();

    const {
        filtersConfig,
        fieldsIds,
        fieldsConfig,
    } = useMemo(() => {

        const filtersConfig = config.filterGroups ?? [];
        const additionalFiltersConfig = config.additionalFilters ?? [];

        const flatFiltersConfig = filtersConfig.reduce(
            (arr, elem) => [
                ...arr,
                ...elem.filters,
            ],
            []
        );

        const fieldsConfig = [
            ...flatFiltersConfig,
            ...additionalFiltersConfig,
        ].reduce(
            (arr, elem) => [
                ...arr,
                ...elem.fields,
            ],
            []
        );

        const fieldsIds = fieldsConfig.reduce((acc, { id, skipValues = false }) => {

            acc[skipValues ? 'withoutValues' : 'withValues'].push(id);

            return acc;

        }, {
            withValues: [],
            withoutValues: [],
        });

        return {
            filtersConfig,
            fieldsIds,
            fieldsConfig,
        };

    }, [config]);

    return {
        filtersConfig,
        fieldsIds,
        fieldsConfig,
    };

};

export default useFiltersConfig;
